export default "__VITE_ASSET__rIUfKz9e__"